module.exports = __webpack_public_path__ + "media/invite/edit-0b6904aa.svg";